import { useCallback, useEffect, useRef } from 'react';

import { fireConfettiBurst, type FireConfettiBurstOptions } from '@src/common/confetti/fireConfettiBurst';

export type UseConfettiBurstOptions = Omit<FireConfettiBurstOptions, 'originElement'>;

export const useConfettiBurst = (defaultOptions: UseConfettiBurstOptions = {}) => {
  const defaultOptionsRef = useRef(defaultOptions);
  defaultOptionsRef.current = defaultOptions;

  const cleanupRef = useRef<(() => void) | null>(null);

  const cleanup = useCallback(() => {
    cleanupRef.current?.();
    cleanupRef.current = null;
    const wrapId = defaultOptionsRef.current.wrapId;
    if (wrapId) {
      document.getElementById(wrapId)?.remove();
    }
  }, []);

  useEffect(() => cleanup, [cleanup]);

  const fireConfetti = useCallback(
    (originElement: HTMLElement | null, overrides: UseConfettiBurstOptions = {}) => {
      cleanup();
      cleanupRef.current = fireConfettiBurst({
        ...defaultOptionsRef.current,
        ...overrides,
        originElement,
      });
    },
    [cleanup],
  );

  return { fireConfetti, cleanup };
};
